import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { formatOptionalDate } from "./formatters";
import { PasswordField, PasswordRequirements } from "./password";
export default function AdminDevelopersView({ portal }) {
  const {
    developers: {
      adminDeveloperForm,
      adminDevelopers,
      handleCreateDeveloper,
      handleDeleteDeveloper,
      handleEditDeveloper,
      isDeveloperEditorOpen,
      isEditingDeveloper,
      openCreateDeveloperForm,
      resetDeveloperForm,
      setAdminDeveloperForm,
      setShowAdminDeveloperPassword,
      showAdminDeveloperPassword,
    },
    ui: { loading },
  } = portal;

  const renderDeveloperEditorForm = () => (
    <div className="support-inline-editor">
      <div className="support-inline-editor-head">
        <div className="support-panel-heading">
          <h3 className="heading-3">{isEditingDeveloper ? "Modifier un développeur" : "Ajouter un développeur"}</h3>
          <p className="body-small">
            Gère l'accès plateforme et conserve l'historique même si le compte est bloqué.
          </p>
        </div>
        <button type="button" className="support-inline-close" onClick={resetDeveloperForm} aria-label="Fermer le bloc d'edition">
          ×
        </button>
      </div>
      <form onSubmit={handleCreateDeveloper} className="support-form-grid">
        <input
          className="form-input"
          type="text"
          placeholder="Nom du développeur"
          value={adminDeveloperForm.full_name}
          onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, full_name: e.target.value })}
          required
        />
        <input
          className="form-input"
          type="email"
          placeholder="Email du développeur"
          value={adminDeveloperForm.email}
          onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, email: e.target.value })}
          required
        />
        <div className="support-span-2">
          <PasswordField
            value={adminDeveloperForm.password}
            onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, password: e.target.value })}
            placeholder={isEditingDeveloper ? "Nouveau mot de passe (optionnel)" : "Mot de passe initial"}
            required={!isEditingDeveloper}
            isVisible={showAdminDeveloperPassword}
            onToggleVisibility={() => setShowAdminDeveloperPassword((current) => !current)}
          />
        </div>
        <div className="support-span-2">
          <PasswordRequirements password={adminDeveloperForm.password} />
        </div>
        <label className="support-checkbox-line support-span-2">
          <input
            type="checkbox"
            checked={adminDeveloperForm.can_access_platform}
            onChange={(e) => setAdminDeveloperForm({ ...adminDeveloperForm, can_access_platform: e.target.checked })}
          />
          Acces autorise a la plateforme
        </label>
        <div className="support-form-actions support-span-2">
          <Button type="submit" className="btn-primary" disabled={loading}>
            {loading ? (isEditingDeveloper ? "Mise à jour..." : "Création...") : (isEditingDeveloper ? "Mettre à jour" : "Créer l'accès")}
          </Button>
          <Button type="button" className="btn-secondary" onClick={resetDeveloperForm} disabled={loading}>
            Annuler
          </Button>
          {isEditingDeveloper && (
            <Button
              type="button"
              className="btn-secondary support-danger-btn"
              onClick={handleDeleteDeveloper}
              disabled={loading}
            >
              Bloquér le compte
            </Button>
          )}
        </div>
      </form>
    </div>
  );

  return (
    <Card className="support-content-card">
      <CardHeader>
        <CardTitle className="heading-2">Développeurs</CardTitle>
      </CardHeader>
      <CardContent className="support-management-list">
        <div className="support-list-toolbar">
          <div>
            <p className="body-small">Clique une ligne pour modifier, ou ajoute un nouvel accès.</p>
          </div>
          <Button type="button" className="btn-primary" onClick={openCreateDeveloperForm}>
            Ajouter un développeur
          </Button>
        </div>
        {isDeveloperEditorOpen && !isEditingDeveloper && renderDeveloperEditorForm()}

        <div className="support-table-list">
          <div className="support-table-row support-table-head" aria-hidden="true">
            <span>Developpeur</span>
            <span>Email</span>
            <span>Acces</span>
            <span>Tickets attribués</span>
            <span>Clients gérés</span>
            <span>Dernière connexion</span>
          </div>
          {adminDevelopers.map((developer) => (
            <div key={developer.id} className="support-table-item">
              <button
                type="button"
                className={`support-table-row ${adminDeveloperForm.id === developer.id ? "is-active" : ""}`}
                onClick={() => handleEditDeveloper(developer)}
              >
                <strong>{developer.full_name}</strong>
                <span>{developer.email}</span>
                <span>{developer.can_access_platform && developer.is_active ? "Actif" : "Bloqué"}</span>
                <span>{developer.assigned_ticket_count} ticket(s) attribué(s)</span>
                <span>{developer.managed_client_count} client(s) géré(s)</span>
                <span>{formatOptionalDate(developer.last_login_at)}</span>
              </button>
              {isDeveloperEditorOpen && adminDeveloperForm.id === developer.id && renderDeveloperEditorForm()}
            </div>
          ))}
          {adminDevelopers.length === 0 && <p className="body-small">Aucun développeur pour le moment.</p>}
        </div>
      </CardContent>
    </Card>
  );
}
